import { delay, getAIEmployerTiming } from '../../mock.config';
import executions from '../data/executions.json';

/* ── In-memory state ───────────────────────────────────────────────────── */
let executionsList = JSON.parse(JSON.stringify(executions));

const clone = (obj) => JSON.parse(JSON.stringify(obj));

export function resetExecutionState() {
  executionsList = JSON.parse(JSON.stringify(executions));
}

export function addExecution(exec) {
  executionsList = [exec, ...executionsList];
}

export function getExecutionById(id) {
  return executionsList.find((e) => e._id === id);
}

export async function handleExecutionRequest(method, url, config) {
  const timing = getAIEmployerTiming();
  await delay(timing.apiDelay);

  // GET /board/:bid/tasks/:tid/executions — list executions
  if (method === 'GET' && /\/tasks\/[^/]+\/executions$/.test(url)) {
    const list = clone(executionsList);
    return {
      status: true,
      body: { executions: list, total: list.length },
    };
  }

  // GET /board/:bid/tasks/:tid/executions/:eid — single execution detail
  if (method === 'GET' && /\/tasks\/[^/]+\/executions\/[^/]+$/.test(url)) {
    const eid = url.split('/executions/')[1]?.split(/[/?]/)[0];
    const exec = executionsList.find((e) => e._id === eid);
    if (exec) return { status: true, body: clone(exec) };
    return { status: false, message: 'Execution not found' };
  }

  // POST /board/:bid/tasks/:tid/executions/:eid/cancel-execution
  if (method === 'POST' && url.includes('/cancel-execution')) {
    const eid = url.split('/executions/')[1]?.split('/')[0];
    const idx = executionsList.findIndex((e) => e._id === eid);
    if (idx >= 0) {
      executionsList[idx] = {
        ...executionsList[idx],
        status: 'cancelled',
        completedAt: new Date().toISOString(),
        durationSeconds: executionsList[idx].startedAt
          ? Math.round((Date.now() - new Date(executionsList[idx].startedAt).getTime()) / 1000)
          : 0,
      };
      return { status: true, message: 'Execution cancelled', body: clone(executionsList[idx]) };
    }
    return { status: false, message: 'Execution not found' };
  }

  // POST /board/:bid/tasks/:tid/executions/:eid/revise — create revision
  if (method === 'POST' && url.includes('/revise')) {
    const eid = url.split('/executions/')[1]?.split('/')[0];
    const body = JSON.parse(config?.data || '{}');
    const parent = executionsList.find((e) => e._id === eid);
    if (!parent) return { status: false, message: 'Original execution not found' };

    const newExec = {
      _id: 'mock-exec-rev-' + Date.now(),
      employerId: body.employerId || parent.employerId,
      memberId: parent.memberId || 'member-' + (body.employerId || parent.employerId),
      subTaskId: parent.subTaskId || null,
      duty: parent.duty || '',
      status: 'queued',
      startedAt: null,
      completedAt: null,
      durationSeconds: null,
      attemptCount: (parent.attemptCount || 0) + 1,
      revisionCount: (parent.revisionCount || 0) + 1,
      parentExecutionId: parent._id,
      revisionPrompt: body.prompt || '',
      plan: { steps: [], currentStep: 0 },
      executionReport: null,
      artifactIds: [],
      logs: [],
      errorMessage: null,
      employerName: parent.employerName || '',
      createdAt: new Date().toISOString(),
    };

    executionsList = [newExec, ...executionsList];
    return { status: true, message: 'Revision queued', body: clone(newExec) };
  }

  return { status: false, message: 'Unknown execution endpoint: ' + method + ' ' + url };
}
